import React, { useContext } from "react";
import { ColorSelector } from "../../components/ColorSelector";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";

const colours = [{ filter: "handleBackgroundColor", display: "background" }];

// const marginTop = 5;

export const HandleFilterPanel = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig } = store;

  const changefilter = (val, key) => {
    const newFilter = { ...flowConfig, [key]: val };
    dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: newFilter });
    dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "block",
      }}
    >
      <ColorSelector
        colours={colours}
        changefilter={changefilter}
        filter={flowConfig}
      />
    </div>
  );
};
